import { Route } from "react-router-dom";
import { PageInterface } from "../interfaces";
import { getSubSections } from "./getMethods";

export const renderPages = (list: PageInterface[], props: any) => {
  const subSectionslvl1 = getSubSections(list);
  const subSectionslvl2 = getSubSections(subSectionslvl1);
  const renderedPages = list
    .concat(subSectionslvl1)
    .concat(subSectionslvl2)
    .map((page: PageInterface, key: number) => {  
      const ele = page.pageElement(props);
      return <Route key={key} path={`${page.pathName}`} element={ele} />;
    });
  return renderedPages;
};
